import React from 'react';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import UnpublishedUsersBody from './body'
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import { getEventDetailsForDateFilter } from '../../../generic/Actions/WidgetActions/DateFilter/utils';
import { getEventDetailsHash } from '../utils';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

const UnpublishedUsers = (props) => {
  const { name, url, helpText, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs(props);
  const filterKey = 'joinedIn';

  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, UnpublishedUsersBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'joined_in_date_range') })
    };
  }

  const eventDetailsBuilder = (state) => {
    const { eventName, dateRange, preset } = getEventDetailsForDateFilter(state, { filterKey })

    return getEventDetailsHash({ eventName, source: name, dateRange, preset, eventCategory: props.eventCategory });
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { eventDetailsBuilder });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      helpText={ helpText }
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default UnpublishedUsers;
